module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_gleitschleifen_trowalisieren_01.064665ef.jpg";